<template>
  <DModal :show-close="false" :isBgOverlay="true" :isCloseOnBgClick="false" @close="$emit('close')" :appendToBody="true"
          style="z-index: 12312312312312" :placeInTop="true">
    <div class="d-modal text-dark" slot="insertComponent">
      <div class="d-modal__header">
        <div>
          <h2>Opret faste tillæg</h2>
          <p class="d-modal__subtitle">{{ subtitleText }}</p>
        </div>
        <div class="font-large icon__bg-circle d-modal__header__close" @click="$emit('close')">
          <span class="icon-cross2"></span>
        </div>
      </div>

      <div class="d-modal__content">
        <div class="create-form__grid">
          <div class="d-input-group cf-loenkode">
            <label class="d-label">Lønkode *</label>
            <DSelect
              ref="loenkodeSelect"
              :items="salaryCodesForDSelect"
              :multiple="false"
              :placeholder="'Vælg lønkode'"
              :itemsSelected="selectedSalaryCodeForDSelect"
              :isShowRemoveButton="false"
              @add="onSelectLoenkode"
              @remove="onSelectLoenkode(null)"
            />
          </div>
          <div class="d-input-group cf-antal">
            <label class="d-label">Enheder pr. måned *</label>
            <input v-model="antal" type="text" inputmode="decimal" class="d-input width-100" placeholder="Indtast antal"/>
          </div>
          <div class="d-input-group cf-beloeb">
            <label class="d-label">{{ beloebAllowed ? 'Beløb *' : 'Beløb' }}</label>
            <span class="cf-beloeb__field"
                  :content="beloebAllowed ? '' : 'Kræver løbenummer 0'"
                  v-tippy="{
                    arrow: true,
                    placement: 'top',
                    animateFill: false,
                    animation: 'shift-away',
                    boundary: 'window',
                    zIndex: 12312312312312,
                    onShow: () => !beloebAllowed
                  }">
              <input v-model="beloeb" type="text" inputmode="decimal" class="d-input width-100"
                     :disabled="!beloebAllowed"
                     :placeholder="beloebAllowed ? 'Indtast beløb' : ''"/>
            </span>
          </div>
          <p class="cf-hint text-explainer">
            {{ beloebHint }}
          </p>
          <div class="d-input-group cf-start">
            <label class="d-label">Startdato *</label>
            <DateSelector class="width-100" :date="startDato" :width100="true" @changed="startDato = $event"/>
          </div>
          <div class="d-input-group cf-slut">
            <label class="d-label">Slutdato *</label>
            <DateSelector v-if="!noEndDate" class="width-100" :date="endDato" :width100="true" @changed="endDato = $event"/>
            <input v-else type="text" class="d-input width-100" :value="openEndedDateLabel" disabled/>
            <label class="cf-no-end-date">
              <input type="checkbox" v-model="noEndDate" @change="onToggleNoEndDate"/>
              <span>Uden slutdato</span>
            </label>
          </div>
          <div class="d-input-group cf-omk">
            <label class="d-label">Afvigende omkostningssted</label>
            <DSelect
              :items="costCentersForDSelect"
              :multiple="false"
              :placeholder="'Vælg afvigende omkostningssted (valgfri)'"
              :itemsSelected="selectedCostCenterForDSelect"
              :isShowRemoveButton="true"
              @add="onSelectCostCenter"
              @remove="onSelectCostCenter(null)"
            />
          </div>
        </div>
        <p v-if="validationMessage" class="text-explainer text-explainer--danger">
          {{ validationMessage }}
        </p>
      </div>

      <div class="d-modal__buttons">
        <div class="d-modal__buttons__child">
          <button class="do-bttn" @click="$emit('close')">{{ $t('vue2.common.cancel') }}</button>
          <button class="do-bttn do-bttn--submit"
                  :class="{'do-bttn--submit--loading': isSubmitting, 'do-bttn--submit--disabled': !isValid}"
                  :disabled="isSubmitting"
                  @click="submit"
                  :content="saveKeyTooltip"
                  v-tippy="{
                    arrow: true,
                      placement : 'top',
                      animateFill: false,
                      animation : 'shift-away',
                      boundary: 'window',
                      zIndex: 12312312312312
                    }">
            {{ submitButtonLabel }}
          </button>
        </div>
      </div>
    </div>
  </DModal>
</template>

<script>
import DModal from '../../common/DModal.vue'
import DateSelector from '../../datepicker/DateSelector.vue'
import moment from 'moment'
import eventbus from '../../../eventbus'
import docendo from '../../../docendo'
import DSelect from '../../DSelect/DSelect.vue'

export default {
  components: {DSelect, DModal, DateSelector},
  props: {
    schoolId: {
      type: Number,
      required: true
    },
    employmentIds: {
      type: Array,
      default: () => []
    },
    subtitle: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      salaryCodeId: null,
      antal: '',
      beloeb: '',
      salaryCostCenterId: null,
      startDato: null,
      endDato: null,
      noEndDate: false,
      isSubmitting: false,
      validationMessage: ''
    }
  },
  computed: {
    subtitleText () {
      if (this.subtitle) return this.subtitle
      return 'På ' + this.employmentIds.length + ' ' + (this.employmentIds.length === 1 ? 'ansættelse' : 'ansættelser')
    },
    metaKey () {
      const isMac = navigator.platform.toUpperCase().indexOf('MAC') >= 0
      return isMac ? '⌘' : 'CTRL'
    },
    saveKeyTooltip () {
      return '<p class="tooltip-shortcut tooltip-shortcut--double-key"><span>' + this.metaKey + '</span>' + '<span>Enter</span></p>'
    },
    submitButtonLabel () {
      if (this.employmentIds.length <= 1) {
        return 'Send til OPUS'
      }
      return 'Send ' + this.employmentIds.length + ' faste tillæg til OPUS'
    },
    // "Uden slutdato" sættes til KMD's åbne slutdato (31-12-9999).
    openEndedDateLabel () {
      return moment('9999-12-31').format('DD-MM-YYYY')
    },
    schoolYearStartDate () {
      const year = this.$store.state.localActivatedSchoolYear
      const firstOfNextMonth = moment().add(1, 'month').startOf('month')
      if (year && year.employee_time_start) {
        const start = moment(year.employee_time_start)
        // Hvis skoleårets start allerede er overskredet, brug den første i næste måned.
        return start.isBefore(moment(), 'day') ? firstOfNextMonth : start
      }
      return firstOfNextMonth
    },
    schoolYearEndDate () {
      const year = this.$store.state.localActivatedSchoolYear
      if (year && year.employee_time_end) {
        return moment(year.employee_time_end)
      }
      return moment().add(1, 'year')
    },
    isValid () {
      const hasSelections = this.employmentIds.length > 0
      const hasStart = !!this.startDato && moment(this.startDato).isValid()
      const hasEnd = !!this.endDato && moment(this.endDato).isValid()
      const hasLoenkode = this.salaryCodeId != null
      const antal = parseFloat(String(this.antal).replace(',', '.'))
      const hasAntal = !isNaN(antal) && antal > 0 && antal <= 9999
      const isEndAfterStart = hasEnd && moment(this.endDato).isSameOrAfter(moment(this.startDato))
      // KMD kode 171: Beløb er obligatorisk når løbenummer er 0 – og kun tilladt der.
      const hasBeloeb = this.beloeb !== '' && this.beloeb != null
      const beloebRule = !this.beloebAllowed || hasBeloeb
      return hasSelections && hasStart && hasEnd && hasLoenkode && hasAntal && beloebRule && this.beloebValid && isEndAfterStart
    },
    // Beløb er valgfrit, men hvis udfyldt: max 99999,99 (jf. KMD's grænse på 8 cifre).
    beloebValid () {
      if (this.beloeb === '' || this.beloeb == null) return true
      const beloeb = parseFloat(String(this.beloeb).replace(',', '.'))
      return !isNaN(beloeb) && Math.abs(beloeb) <= 99999.99
    },
    // Liste over felter der mangler/er ugyldige, brugt til toast-feedback ved klik.
    missingFields () {
      const missing = []
      if (this.employmentIds.length === 0) missing.push('mindst én ansættelse')
      if (this.salaryCodeId == null) missing.push('lønkode')
      const antal = parseFloat(String(this.antal).replace(',', '.'))
      if (isNaN(antal) || antal <= 0) missing.push('antal')
      else if (antal > 9999) missing.push('et gyldigt antal (maks. 9.999)')
      if (this.beloebAllowed && (this.beloeb === '' || this.beloeb == null)) missing.push('beløb (lønkoden har løbenummer 0)')
      if (!this.beloebValid) missing.push('et gyldigt beløb (maks. 99.999,99)')
      const hasStart = !!this.startDato && moment(this.startDato).isValid()
      const hasEnd = !!this.endDato && moment(this.endDato).isValid()
      if (!hasStart) missing.push('startdato')
      if (!hasEnd) missing.push('slutdato')
      else if (hasStart && moment(this.endDato).isBefore(moment(this.startDato))) {
        missing.push('en slutdato efter startdato')
      }
      return missing
    },
    salaryCodes () {
      return this.$store.getters.salaryCodesSorted || []
    },
    salaryCodesForDSelect () {
      if (!this.salaryCodes || !Array.isArray(this.salaryCodes)) {
        return []
      }
      return this.salaryCodes
        .filter(sc => sc.loenart)
        .map(sc => {
          const value = sc.loenart != null ? sc.loenart : sc.code
          const displayValue = value != null ? String(value) : ''
          const name = sc.name || ''
          return {
            id: sc.id,
            name: displayValue + (name ? ' - ' + name : ''),
            value: value,
            original: sc
          }
        })
    },
    selectedSalaryCodeForDSelect () {
      if (this.salaryCodeId == null) {
        return []
      }
      const found = this.salaryCodesForDSelect.find(item => item.id === this.salaryCodeId)
      return found ? [found] : []
    },
    selectedSalaryCode () {
      const found = this.salaryCodesForDSelect.find(item => item.id === this.salaryCodeId)
      return found ? found.original : null
    },
    // KMD: Beløb må kun indberettes når løbenummer er 0 (fejlkode 171).
    // Løbenummeret er lønkodens sidste ciffer.
    beloebAllowed () {
      return !!this.selectedSalaryCode && String(this.selectedSalaryCode.loenart).slice(-1) === '0'
    },
    beloebHint () {
      if (this.beloebAllowed) {
        return 'Lønkoden har løbenummer 0, så Beløb skal udfyldes. Antal ganges på beløbet.'
      }
      if (this.selectedSalaryCode) {
        return 'Angiv Antal – taksten for lønkoden anvendes. Beløb kan kun angives for lønkoder med løbenummer 0 (sidste ciffer).'
      }
      return 'Beløb kan kun angives for lønkoder med løbenummer 0 (sidste ciffer); ellers angives Antal.'
    },
    costCenters () {
      return this.$store.getters.costCenters || []
    },
    costCentersForDSelect () {
      return this.costCenters.map(cc => {
        const code = cc.code != null ? String(cc.code) : ''
        const title = cc.title || cc.name || ''
        return {
          id: cc.id,
          name: code + (title ? ' - ' + title : ''),
          value: code,
          original: cc
        }
      })
    },
    selectedCostCenterForDSelect () {
      if (this.salaryCostCenterId == null) {
        return []
      }
      const found = this.costCentersForDSelect.find(item => item.id === this.salaryCostCenterId)
      return found ? [found] : []
    }
  },
  watch: {
    // Ryd et indtastet beløb hvis brugeren skifter til en lønkode, hvor beløb ikke er tilladt,
    // så der ikke hænger en skjult værdi ved i payloaden.
    beloebAllowed (allowed) {
      if (!allowed) {
        this.beloeb = ''
      }
    }
  },
  methods: {
    onSelectLoenkode (item) {
      this.salaryCodeId = item ? item.id : null
    },
    onSelectCostCenter (item) {
      this.salaryCostCenterId = item ? item.id : null
    },
    onToggleNoEndDate () {
      if (this.noEndDate) {
        this.endDato = moment('9999-12-31')
      } else {
        this.endDato = this.schoolYearEndDate
      }
    },
    onGlobalKeydown (evt) {
      const isSubmitCombo = (evt.metaKey || evt.ctrlKey) && (evt.key === 'Enter' || evt.keyCode === 13)
      if (!isSubmitCombo) return
      if (this.isSubmitting || !this.isValid) return
      evt.preventDefault()
      this.submit()
    },
    submit () {
      this.validationMessage = ''
      if (!this.isValid) {
        const missing = this.missingFields
        if (missing.length) {
          const text = missing.length === 1
            ? `Udfyld ${missing[0]}`
            : `Mangler: ${missing.join(', ')}`
          eventbus.toast = {text, success: false, position: 'bottomLeft'}
        }
        return
      }
      if (!this.schoolId) {
        this.validationMessage = 'Mangler schoolId'
        return
      }

      // Backenden udleder selv lønart/løbenummer fra salary_code_id og omkostningssted fra salary_cost_center_id.
      const recurringPayment = {
        startdato: moment(this.startDato).format('YYYY-MM-DD'),
        stopdato: moment(this.endDato).format('YYYY-MM-DD'),
        salary_code_id: this.salaryCodeId,
        antal: parseFloat(String(this.antal).replace(',', '.'))
      }
      if (this.beloeb !== '' && this.beloeb != null) {
        recurringPayment.beloeb = parseFloat(String(this.beloeb).replace(',', '.'))
      }
      if (this.salaryCostCenterId != null) {
        recurringPayment.salary_cost_center_id = this.salaryCostCenterId
      }

      this.isSubmitting = true
      docendo.createRecurringPaymentForEmployees(
        this.schoolId,
        this.employmentIds,
        recurringPayment,
        success => {
          this.isSubmitting = false
          if (success && success.status === 'error') {
            this.validationMessage = success.message || 'Kunne ikke oprette faste tillæg'
            eventbus.toast = {text: 'Kunne ikke oprette faste tillæg', success: false, position: 'bottomLeft'}
            return
          }
          const count = Array.isArray(success) ? success.length : this.employmentIds.length
          eventbus.toast = {
            text: (count === 1 ? 'Fast tillæg' : count + ' faste tillæg') + ' sendt til behandling. Følg status i Udbakke.',
            success: true,
            position: 'bottomLeft'
          }
          this.$emit('created', success)
          this.$emit('close')
        },
        failure => {
          console.log('failure', failure)
          this.isSubmitting = false
          eventbus.toast = {text: 'Kunne ikke oprette faste tillæg', success: false, position: 'bottomLeft'}
        }
      )
    }
  },
  created () {
    this.startDato = this.schoolYearStartDate
    this.endDato = this.schoolYearEndDate
  },
  mounted () {
    this.$store.dispatch('readSalaryCodes')
    this.$store.dispatch('readCostCenters')
    window.addEventListener('keydown', this.onGlobalKeydown)
    // Fokusér lønkode-feltet uden at åbne dropdownen; den åbner først når brugeren taster.
    this.$nextTick(() => {
      setTimeout(() => {
        if (this.$refs.loenkodeSelect) this.$refs.loenkodeSelect.setFocus()
      }, 300)
    })
  },
  beforeDestroy () {
    window.removeEventListener('keydown', this.onGlobalKeydown)
  }
}
</script>

<style scoped>
@import "../../../assets/css/variables.css";

.d-modal {
  width: 640px;
  max-width: calc(100vw - 32px);
  border-radius: 16px;
  position: relative;
}

.d-modal__header {
  margin-bottom: 0;
  text-align: left;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}

.d-modal__subtitle {
  margin: 0.25rem 0 0;
  font-size: 13px;
  color: #6b7280;
}

.d-modal__content {
  padding: 1rem;
  overscroll-behavior: contain;
  max-height: calc(100vh - 52px - 80px);
  overflow-y: auto;
}

.d-modal__buttons {
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
  padding: 1rem 2rem;
  border-top: 1px solid #eee;
  margin: 0;
}

.d-modal__buttons__child {
  display: flex;
  gap: 0.5rem;
}

.create-form__grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 0.75rem;
}

/* Eksplicit placering så relaterede felter grupperes logisk. */
.cf-loenkode {
  grid-column: 1 / -1;
  grid-row: 1;
}

.cf-antal {
  grid-column: 1;
  grid-row: 2;
}

.cf-beloeb {
  grid-column: 2;
  grid-row: 2;
}

.cf-hint {
  grid-column: 1 / -1;
  grid-row: 3;
  margin: -0.25rem 0 0;
  padding: 0 1rem;
}

.cf-start {
  grid-column: 1;
  grid-row: 4;
}

.cf-slut {
  grid-column: 2;
  grid-row: 4;
}

.cf-omk {
  grid-column: 1;
  grid-row: 5;
}

.cf-no-end-date {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  margin-top: 0.4rem;
  font-size: 12px;
  cursor: pointer;
}

.cf-no-end-date input {
  cursor: pointer;
  margin: 0;
}

.d-input-group .d-input {
  height: 34px;
}

.cf-beloeb__field {
  display: block;
  width: 100%;
}

/* Sikr at hover rammer wrapperen (og dermed tooltippet), også når feltet er disabled. */
.cf-beloeb__field input:disabled {
  pointer-events: none;
}

.d-input-group .d-input:disabled {
  background: #f3f4f6;
  color: #9ca3af;
  cursor: not-allowed;
}

.d-input-group {
  margin-bottom: 0.5rem;
}

.text-explainer--danger {
  color: var(--danger);
  margin-top: 0.5rem;
}
</style>



// WEBPACK FOOTER //
// CreateFastTillaeg.vue?ca81113c